var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8481,31.593c-1.8195-1.5506-4.5256-1.2717-6.1957.4516l-.6541.674-.6541-.674c-1.6668-1.7233-4.3762-2.0022-6.1957-.4516-2.0852,1.7797-2.1947,4.9738-.3287,6.9029l6.4248,6.634c.415.4283,1.089.4283,1.5041,0l6.4248-6.634c1.8693-1.9291,1.7598-5.1232-.3254-6.9029Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6236,29.6011v11.3123l2.75,1.9243v-13.2366l9.0854-9.0865H13.5385l9.0851,9.0865ZM35.7124,19.261s.0002-.0002,0,0ZM21.1635,42.3327c-.3384-.2369-.5399-.6239-.5399-1.0369v-10.8664l-9.7528-9.7542c-.7965-.7966-.2293-2.1606.8949-2.1606h24.466c1.1265,0,1.6899,1.3656.895,2.1606l-9.7531,9.7542v13.8185c0,1.029-1.1591,1.6195-1.9914,1.0369l-4.2187-2.9521Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1583,6.291c4.6891-3.1332,10.2022-4.8055,15.8417-4.8055h.0011c7.5596.0085,14.8072,3.0153,20.1527,8.3608,5.3454,5.3454,8.3522,12.593,8.3607,20.1527,0,5.6396-1.6723,11.1536-4.8055,15.8428-3.1332,4.6891-7.5866,8.3439-12.7969,10.5021-5.2104,2.1582-10.9437,2.7229-16.475,1.6227-5.5312-1.1003-10.612-3.816-14.5998-7.8038-3.9879-3.9879-6.7036-9.0687-7.8038-14.5999-1.1003-5.5313-.5356-11.2646,1.6226-16.475,2.1582-5.2103,5.8131-9.6636,10.5022-12.7969ZM39.7093,6.5601c-4.636-1.9203-9.7373-2.4227-14.6588-1.4438-4.9215.979-9.4422,3.3953-12.9905,6.9436-3.5483,3.5483-5.9646,8.0689-6.9435,12.9904-.979,4.9215-.4765,10.0228,1.4438,14.6588,1.9202,4.636,5.1721,8.5984,9.3444,11.3862,4.172,2.7876,9.0768,4.2756,14.0944,4.2758,6.7268-.0075,13.1759-2.6831,17.9325-7.4397,4.7566-4.7565,7.4321-11.2056,7.4397-17.9324-.0002-5.0176-1.4882-9.9225-4.2758-14.0945-2.7878-4.1723-6.7503-7.4241-11.3862-9.3444Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLike);
export default __webpack_public_path__ + "static/media/filter-like.abd18f1c8b223f91ad4720da655a8b80.svg";
export { ForwardRef as ReactComponent };